<div class="welcomePopup">
  <div>
    <p>
      Thank you for registering! You are just couple of steps away from signing
      in -
    </p>
    <p>1. Complete the process by checking your email for verification link.</p>
    <p>
      2. Click the link in the email to verify your account and proceed to
      login.
    </p>
    <div>
      <button (click)="backtologin()">
        {{
          appContext?.siteName !== "Gocaribbea" ? "Back to login" : "Login Now"
        }}
      </button>
    </div>
  </div>
</div>
